import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {PassOnLogService} from '../../services/pass-on-log.service';
import {PassOnLogComponent} from './pass-on-log.component';
import {PassOnLogListComponent} from './pass-on-log-list/pass-on-log-list.component';
import {PassOnLogModalComponent} from './pass-on-log-modal/pass-on-log-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {PassOnLogFilterComponent} from '../../components/pass-on-log-filter/pass-on-log-filter.component';
import {PassOnLogStatusHistoryComponent} from './pass-on-log-status-history/pass-on-log-status-history.component';
import {PassOnLogHistoryComponent} from './pass-on-log-history/pass-on-log-history.component';
import {ViewPassOnLogModalComponent} from './view-pass-on-log-modal/view-pass-on-log-modal.component';
import {PassOnLogDetailedViewComponent} from './pass-on-log-detailed-view/pass-on-log-detailed-view.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        PassOnLogComponent,
        PassOnLogListComponent,
        PassOnLogModalComponent,
        PassOnLogFilterComponent,
        PassOnLogStatusHistoryComponent,
        PassOnLogHistoryComponent,
        ViewPassOnLogModalComponent,
        PassOnLogDetailedViewComponent
    ],
    exports: [
        PassOnLogModalComponent
    ],
    providers: [
        PassOnLogService
    ]
})
export class PassOnLogModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log.module.ts